export default __webpack_public_path__ + "static/partnerIcon18-f1e87642178a412a2d06017fbc2499a5.svg";